import React from "react";
import {BlogCollectionTile} from "./blogCollectionTile";
import PropTypes from "prop-types";

export const BlogCollection = ({items}) => {
    return (
        items?.length > 0 ? (
            <div className="blog-collection">
                <h3 className="blog-collection-item-title">
                    <a
                        className="stretched-link blog-collection-title"
                        href="https://blog.but.fr/"
                    >
                        Trouvez votre{" "}
                        <span className="blog-collection-title-highlight">inspiration</span>
                    </a>
                </h3>
                <ul className="blog-collection-list">
                    {items.map((props, index) => {
                        return (
                            <>
                                <li className="blog-collection-item overflow-hidden-class" key={index}>
                                    <BlogCollectionTile {...props} />
                                </li>
                            </>
                        );
                    })}
                </ul>
            </div>
        ) : null
    );
};

BlogCollection.propTypes = {
    items: PropTypes.array,
};

BlogCollection.defaultProps = {
    items: [],
};
